import React, { useState, useEffect } from 'react';

import Carousel from '../../shared/Carousel';
import PrimarySlide from './order_detail_screens/PrimarySlide';
import SecondarySlide from './order_detail_screens/SecondarySlide';
import useCarousel from '../../../hooks/useCarousel';

export default function OrderInfoSlider({ product, order, entity }) {
  const [merchant, setMerchant] = useState();
  const availableSlides = ['primary', 'secondary'];

  const { activeSlide, slideIndex, nextSlide, previousSlide, resetSlide } =
    useCarousel(availableSlides, 'primary');
  
  const slideProps = { entity, product, merchant, order };

  const getSlide = () => {
    if (!activeSlide) return null;

    switch (activeSlide) {
      case 'primary':
        return <PrimarySlide {...slideProps} />;
      case 'secondary':
        return <SecondarySlide {...slideProps} />;
      default:
        return <PrimarySlide {...slideProps} />;
    }
  };

  useEffect(() => {
    setMerchant(order?.merchant)
    resetSlide();
  }, [order]);

  return (
    <div className="my-6">
      <Carousel
        containerClass="rounded bg-light-blue px-8 pt-6 py-5 shadow min-h-[12rem]"
        previousOnClick={previousSlide}
        nextOnClick={nextSlide}
        previousBtnClass={!slideIndex ? "hover:text-gray-300 text-gray-300 hover:cursor-not-allowed" : "text-black opacity-50 hover:text-black bg-none"}
        nextBtnClass={(slideIndex === availableSlides.length - 1) ? "hover:text-gray-300 text-gray-300 hover:cursor-not-allowed" : "text-black opacity-50 hover:text-black bg-none"}
      >
        <div className="text-black w-5/6">{getSlide()}</div>
      </Carousel>
    </div>
  );
}